/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Art_NoteInputs */

const en_svc_integration_art_note = /** @type {(inputs: Svc_Integration_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative extraction. Your documents define the fields.`)
};

const lv_svc_integration_art_note = /** @type {(inputs: Svc_Integration_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīva datu ieguve. Laukus nosaka Jūsu dokumenti.`)
};

/**
* | output |
* | --- |
* | "Illustrative extraction. Your documents define the fields." |
*
* @param {Svc_Integration_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_art_note = /** @type {((inputs?: Svc_Integration_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_art_note(inputs)
	return en_svc_integration_art_note(inputs)
});